import { safeApiRequest } from './apiClient';

/**
 * İade kargo listesi
 */
export const fetchIadeKargolari = async ({ durum, arama, sayfa = 1, limit = 20, randevuIds, servisKaydiId } = {}) => {
  const query = { sayfa, limit };
  if (durum) query.durum = durum;
  if (arama && arama.trim()) query.arama = arama.trim();
  if (servisKaydiId) query.servisKaydiId = servisKaydiId;
  if (randevuIds && Array.isArray(randevuIds) && randevuIds.length > 0) {
    query.randevuIds = randevuIds.join(',');
  } else if (randevuIds && typeof randevuIds === 'string') {
    query.randevuIds = randevuIds;
  }

  const response = await safeApiRequest('/api/iade-kargolari', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * İade kargo detayı
 */
export const fetchIadeKargoDetay = async (id) => {
  const response = await safeApiRequest(`/api/iade-kargolari/${id}`, {
    method: 'GET',
    skipCsrf: true,
  });
  return response;
};

/**
 * İade kargo bilgisi gir (kargo firması, takip no)
 */
export const iadeKargoKargoGir = async (id, { kargoFirmasi, kargoTakipNo }) => {
  const response = await safeApiRequest(`/api/iade-kargolari/${id}/kargo`, {
    method: 'PATCH',
    body: { kargoFirmasi, kargoTakipNo },
  });
  return response;
};

/**
 * İade kargo teslim alındı (Admin – fabrikada teslim alındığında)
 */
export const iadeKargoKargoTeslimAl = async (id) => {
  const response = await safeApiRequest(`/api/iade-kargolari/${id}/kargo-teslim-al`, {
    method: 'PATCH',
  });
  return response;
};
